<template>
  <div>
    <pie-chart
      chartId="ticket-chart"
      :chartData="chartData"
      :colors="chartColorFunc"
    ></pie-chart>
  </div>
</template>

<script>
import { getTicketCount } from '@/api/itsm'
import PieChart from '@/components/chart/PieChart.vue'

export default {
  name: 'TicketChart',
  components: {
    PieChart
  },
  data () {
    return {
      chartData: []
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      getTicketCount().then(res => {
        if (res.data) {
          this.chartData = res.data.data.map(item => {
            return {
              name: this.$t(`ticket_status.${item.name}`),
              value: item.value
            }
          })
        } else this.chartData = []
      })
    },
    chartColorFunc (v) {
      if (v === '处理中') return '#69c66f'
      else return '#bababa'
    }
  }
}
</script>

<style>

</style>
